import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/areamange',
    meta: { title: '区域管理' },
    component: Layout,
    redirect: '/areamange/list',
    children: [
      {
        path: 'list',
        meta: {
          title: '区域管理',
          activeMenu: '/areamange/list'
        },
        component: () => import('@/views/areamange/AreaMange.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增区域',
          activeMenu: '/areamange/list'
        },
        component: () => import('@/views/areamange/AreaMangeAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑区域',
          activeMenu: '/areamange/list'
        },
        component: () => import('@/views/areamange/AreaMangeAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '区域详情',
          activeMenu: '/areamange/list'
        },
        component: () => import('@/views/areamange/AreaMangeDetail.vue')
      }

    ]
  },
  {
    path: '/gridmanage',
    meta: { title: '网格管理' },
    component: Layout,
    redirect: '/gridmanage/list',
    children: [
      {
        path: 'list',
        meta: {
          title: '网格管理',
          activeMenu: '/gridmanage/list'
        },
        component: () => import('@/views/gridmanage/GridMange.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增网格',
          activeMenu: '/gridmanage/list'
        },
        component: () => import('@/views/gridmanage/GridMangeAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑网格',
          activeMenu: '/gridmanage/list'
        },
        component: () => import('@/views/gridmanage/GridMangeAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '网格详情',
          activeMenu: '/gridmanage/list'
        },
        component: () => import('@/views/gridmanage/GridMangeDetail.vue')
      }

    ]
  },
  {
    path: '/checkresult',
    meta: { title: '检查结果' },
    component: Layout,
    redirect: '/checkresult/list',
    children: [
      {
        path: 'list',
        meta: {
          title: '检查结果',
          activeMenu: '/checkresult/list'
        },
        component: () => import('@/views/checkresult/CheckResult.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增检查结果',
          activeMenu: '/checkresult/list'
        },
        component: () => import('@/views/checkresult/CheckResultAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑检查结果',
          activeMenu: '/checkresult/list'
        },
        component: () => import('@/views/checkresult/CheckResultAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '检查结果详情',
          activeMenu: '/checkresult/list'
        },
        component: () => import('@/views/checkresult/CheckResultDetail.vue')
      }

    ]
  }
]
